import { useTranslation } from "react-i18next";
import { 
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,} from "@material-ui/core";
import ErrorDialog from "../ErrorDialog";
import { red } from "@material-ui/core/colors";

const SaveConfDialog = ({isError, openAlert, setOpenAlert, resetForm, connectionErrorMsg, setConnectionErrorMsg, openNotCompatible, setOpenNotCompatible}) => {
    var {t} = useTranslation();

    return (<>
        <ErrorDialog errorMsg={connectionErrorMsg} clearError={() => setConnectionErrorMsg("")} />

        <Dialog open={openAlert}>
            <DialogTitle style={{ color: isError && red[500] }}>
                {isError ? t("devices.setUp.dialog.title.error") : t("devices.setUp.dialog.title")}
            </DialogTitle>
            <DialogContent>
            <DialogContentText>{
                isError ? t("devices.setUp.dialog.description.error") : t("devices.setUp.dialog.descriptionWithSync")}
            </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button
                onClick={() => {setOpenAlert(false);!isError && resetForm();}}
                variant="outlined"
                color="primary"
            >
                {!isError ? t("devices.setUp.dialog.agree") : t("devices.setUp.dialog.agree")}
            </Button>
            </DialogActions>
        </Dialog>

        <Dialog open={openNotCompatible}>
            <DialogTitle style={{ color: red[500] }}>{t("devices.setUp.dialog.notcompatibe.title")}</DialogTitle>
            <DialogContent>
            <DialogContentText>{t("devices.setUp.dialog.notcompatibe.description")}</DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button
                onClick={() => {setOpenNotCompatible(false);}}
                variant="text"
                color="primary">
                {t("devices.setUp.dialog.agree")}
            </Button>
            </DialogActions>
        </Dialog>
    </>);
}

export default SaveConfDialog;